import { CrewMember } from '@legacy-types';

import { api } from '@shared/api/api';

export const getCrewMember = api.createShow<CrewMember>('crew-members/:id');
